/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedTakedownEvent
 */
export interface PatchedTakedownEvent {
    /**
     * 
     * @type {number}
     * @memberof PatchedTakedownEvent
     */
    readonly id?: number;
    /**
     * When this event occurred
     * @type {Date}
     * @memberof PatchedTakedownEvent
     */
    readonly eventDate?: Date;
    /**
     * Description of the takedown action or progress
     * @type {string}
     * @memberof PatchedTakedownEvent
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedTakedownEvent
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedTakedownEvent
     */
    readonly updatedAt?: Date;
}

/**
 * Check if a given object implements the PatchedTakedownEvent interface.
 */
export function instanceOfPatchedTakedownEvent(value: object): value is PatchedTakedownEvent {
    return true;
}

export function PatchedTakedownEventFromJSON(json: any): PatchedTakedownEvent {
    return PatchedTakedownEventFromJSONTyped(json, false);
}

export function PatchedTakedownEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTakedownEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'eventDate': json['event_date'] == null ? undefined : (new Date(json['event_date'])),
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedTakedownEventToJSON(json: any): PatchedTakedownEvent {
      return PatchedTakedownEventToJSONTyped(json, false);
  }

  export function PatchedTakedownEventToJSONTyped(value?: Omit<PatchedTakedownEvent, 'id'|'event_date'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

